/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LinkPreviewItem } from './LinkPreviewItem';
import {
    LinkPreviewItemFromJSON,
    LinkPreviewItemFromJSONTyped,
    LinkPreviewItemToJSON,
    LinkPreviewItemToJSONTyped,
} from './LinkPreviewItem';

/**
 * 
 * @export
 * @interface LinkPreviewDto
 */
export interface LinkPreviewDto {
    /**
     * 
     * @type {number}
     * @memberof LinkPreviewDto
     */
    totalRows?: number;
    /**
     * 
     * @type {number}
     * @memberof LinkPreviewDto
     */
    linkedRows?: number;
    /**
     * 
     * @type {number}
     * @memberof LinkPreviewDto
     */
    unlinkedRows?: number;
    /**
     * 
     * @type {Array<LinkPreviewItem>}
     * @memberof LinkPreviewDto
     */
    samples?: Array<LinkPreviewItem> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkPreviewDto
     */
    orphanedJoinKeys?: Array<string> | null;
}

/**
 * Check if a given object implements the LinkPreviewDto interface.
 */
export function instanceOfLinkPreviewDto(value: object): value is LinkPreviewDto {
    return true;
}

export function LinkPreviewDtoFromJSON(json: any): LinkPreviewDto {
    return LinkPreviewDtoFromJSONTyped(json, false);
}

export function LinkPreviewDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkPreviewDto {
    if (json == null) {
        return json;
    }
    return {
        
        'totalRows': json['totalRows'] == null ? undefined : json['totalRows'],
        'linkedRows': json['linkedRows'] == null ? undefined : json['linkedRows'],
        'unlinkedRows': json['unlinkedRows'] == null ? undefined : json['unlinkedRows'],
        'samples': json['samples'] == null ? undefined : ((json['samples'] as Array<any>).map(LinkPreviewItemFromJSON)),
        'orphanedJoinKeys': json['orphanedJoinKeys'] == null ? undefined : json['orphanedJoinKeys'],
    };
}

export function LinkPreviewDtoToJSON(json: any): LinkPreviewDto {
    return LinkPreviewDtoToJSONTyped(json, false);
}

export function LinkPreviewDtoToJSONTyped(value?: LinkPreviewDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalRows': value['totalRows'],
        'linkedRows': value['linkedRows'],
        'unlinkedRows': value['unlinkedRows'],
        'samples': value['samples'] == null ? undefined : ((value['samples'] as Array<any>).map(LinkPreviewItemToJSON)),
        'orphanedJoinKeys': value['orphanedJoinKeys'],
    };
}

